/**
 * 引数から、パンクズの構造化データの元になるデータを生成する
 */

import Breadcrumbs from '../../../@types/component-data-types'
import CONSTANT from '@utility/constant'

type Breadcrumb = {
  item: string
  name: string
  position: string
}

type Breadcrumbs = Array<Breadcrumb>

export default function generateBreadCrumb(items?:Breadcrumbs):Breadcrumbs {
  const breadcrumbs:Array<any> = []

  if (!items) {
    return breadcrumbs.concat(CONSTANT.BREADCRUMB_TOP_PAGE)
  }

  return breadcrumbs.concat(CONSTANT.BREADCRUMB_TOP_PAGE,items)
}
